"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableBulletChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var Visualization_1 = require("../../../interfaces/Visualization");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var bucket_1 = require("../../../constants/bucket");
var sort_1 = require("../../../utils/sort");
var bulletChartUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/bulletChartUiConfigHelper");
var uiConfig_1 = require("../../../constants/uiConfig");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var BulletChartConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/BulletChartConfigurationPanel"));
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var bucketHelper_2 = require("./bucketHelper");
var drillDownUtil_1 = require("../drillDownUtil");
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var PluggableBulletChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableBulletChart, _super);
    function PluggableBulletChart(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.BULLET;
        _this.supportedPropertiesList = supportedProperties_1.BULLET_CHART_SUPPORTED_PROPERTIES;
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableBulletChart.prototype.getUiConfig = function () {
        return cloneDeep_1.default(this.isMultipleDatesEnabled() ? uiConfig_1.BULLET_CHART_CONFIG_MULTIPLE_DATES : uiConfig_1.DEFAULT_BULLET_CHART_CONFIG);
    };
    PluggableBulletChart.prototype.getExtendedReferencePoint = function (referencePoint) {
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: this.getUiConfig() });
        var buckets = bucketHelper_2.transformBuckets(newReferencePoint.buckets);
        if (!bucketHelper_1.isComparisonAvailable(buckets, newReferencePoint.filters)) {
            // When in first measure bucket after transformBuckets is just one PoP measure and DataFilter is not related
            // than in configureOverTimeComparison method this measure is removed and chart stay in inconstant state
            // after 1st transformBuckets we have to check if comparison is not available and than remove all derived measures
            // from original reference point and than transform buckets again
            newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
            buckets = bucketHelper_2.transformBuckets(newReferencePoint.buckets);
        }
        newReferencePoint[bucket_1.BUCKETS] = buckets;
        newReferencePoint = bulletChartUiConfigHelper_1.getBulletChartUiConfig(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, true);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggableBulletChart.prototype.addFiltersForBullet = function (source, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var cutIntersection = sdk_ui_1.getIntersectionPartAfter(event.drillContext.intersection, clicked);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    PluggableBulletChart.prototype.getInsightWithDrillDownApplied = function (source, drillDownContext) {
        var withFilters = this.addFiltersForBullet(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    PluggableBulletChart.prototype.renderConfigurationPanel = function (insight) {
        if (document.querySelector(this.configPanelElement)) {
            react_dom_1.render(react_1.default.createElement(BulletChartConfigurationPanel_1.default, { locale: this.locale, references: this.references, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, colors: this.colors, pushData: this.handlePushData, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags }), document.querySelector(this.configPanelElement));
        }
        return null;
    };
    PluggableBulletChart.prototype.mergeDerivedBucketItems = function (referencePoint, bucket, newDerivedBucketItems) {
        return bucket.items.reduce(function (resultItems, bucketItem) {
            resultItems.push(bucketItem);
            var newDerivedBucketItem = bucketHelper_1.findDerivedBucketItem(bucketItem, newDerivedBucketItems);
            var shouldAddItem = newDerivedBucketItem &&
                !bucketHelper_1.isDerivedBucketItem(bucketItem) &&
                !bucketHelper_1.hasDerivedBucketItems(bucketItem, referencePoint.buckets);
            if (shouldAddItem) {
                resultItems.push(newDerivedBucketItem);
            }
            return resultItems;
        }, []);
    };
    PluggableBulletChart.prototype.checkBeforeRender = function (insight) {
        _super.prototype.checkBeforeRender.call(this, insight);
        var measureBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.MEASURES);
        if (!measureBucket || sdk_model_1.bucketIsEmpty(measureBucket)) {
            // unmount on error, AD cant recover in some scenarions
            this.unmount();
            throw new Visualization_1.InvalidBucketsSdkError();
        }
        return true;
    };
    return PluggableBulletChart;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggableBulletChart = PluggableBulletChart;
//# sourceMappingURL=PluggableBulletChart.js.map